<template>
  <div class="user-center__requirement-edit-container user-center__common-child-container --for-edit">
    <div class="requirement-edit__wrapper center-common-form-wrapper" :class="{
      disabled: formDisabled
    }">
      <p v-if="formDisabled" class="disabled-hint">请联系工作人员，绑定厂家之后才可以发布重点项目。</p>
      <!-- 顶部 -->
      <sub-page-header>
        <template #title>
          <router-link tag="div" :to="nav.url" active-class="active" class="title__front-item"
            v-for="(nav, index) in breadcrumbs" :key="index">{{ nav.name }}</router-link>
        </template>
        <template #hint>
          <p>
            为保证上架速度，请保证设计包完整度及真实性，带有<i class="circle"></i>的项目是必填的项目
          </p>
        </template>
      </sub-page-header>
      <!-- form部分 -->
      <user-form :form="form" :rules="rules" :render="renderItems" ref="postForm" @formValidated="onSubmit"
        @formValidateError="onFormError" :divider="dividerConfig">
        <template #hint v-if="type !== 'important'">
          <div class="form-hint__text">
            <p>
              免费发布您的手机号将在前台公布，付费发布您的手机号将被隐藏，公开手机号发布您的手机号将在前台显示，任何人都可以与您联系，该情况适合简单的材料咨询，
              隐藏手机号发布只有付费用户与特定商家才能与您联系，该情况适合您特定的材料需求。
            </p>
          </div>
        </template>
        <template #bts>
          <el-button v-for="(bt, btindex) in renderBts" :key="btindex" class="bt__item"
            :class="[bt.type === 'submit' ? 'bt__submit' : 'bt__cancel', bt.classes]"
            @click="bt.onClick && bt.onClick(bt.extendParams, $event)" :data-index="btindex"
            :loading="Number(btCurrentIndex) === Number(btindex) && loading"
            :disabled="formDisabled || Number(btCurrentIndex) !== Number(btindex) && loading">{{ bt.label }}</el-button>
        </template>
      </user-form>
    </div>
    <pay-qrcode :visible.sync="pay.visible" :body="pay.desc" :price="pay.price" @afterPay="afterPay"></pay-qrcode>
    <el-dialog custom-class="tel-dialog" title="推荐商户" :visible.sync="telVisible" width="1000px">
      <div class="cart__main-body">
        <table class="gridtable">
          <tr>
            <th class="spec" width="50px">序号</th>
            <th class="spec" width="300px">商户名称</th>
            <th class="spec" width="150px">联系人</th>
            <th class="spec" width="150px">联系电话</th>
            <th class="spec" width="358px">商户信息</th>
            <!-- <th class="spec">操作</th> -->
          </tr>
          <tr v-for="(item, index) in telList" :key="index">
            <td class="spec" style="text-align: left;">{{ index + 1 }}</td>
            <td class="spec" style="text-align: left;">
              <p style="">{{ item.name }}</p>
            </td>
            <td class="spec" style="text-align: left;">
              <p>{{ item.contact }}</p>
            </td>
            <td style="text-align: left;">
              <p>{{ item.phone }}</p>
            </td>
            <td class="spec" style="text-align: left;">
              <p class="ellipsis1">{{ item.content }}</p>
            </td>

            <!-- <td class="spec" style="text-align: center;">
                  <el-button class="black"  :data-id="item.id" size="mini" @click="onTel(item)">拨打电话</el-button>
            </td>-->
          </tr>
        </table>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="onClose">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { molds } from '@/api/common';
import { belongedMerchants } from '@/api/user'
import { create, getDemandForRandomStoreList } from '@/api/requirement';
import { mapState } from 'vuex';
import PayQrcode from '@/pages/common/payQrcode.vue';
import SubPageHeader from '../_pageHeader.vue';
import UserForm from '../_form.vue';
import { IDENTITY_DEALER } from '@/assets/utils/dict'

export default {
  components: {
    SubPageHeader,
    UserForm,
    PayQrcode,
  },
  props: {
    id: undefined,
  },
  computed: mapState({
    userInfo: ({ user: { info } }) => info,
    molds: (state) => state.molds,
    cities: (state) => state.cities,
    isNew() {
      return this.id === undefined;
    },
    // 判断是不是直接发布important
    type() {
      const { type } = this.$route.query
      return type || null
    },
  }),
  data() {
    return {
      loading: false,
      telList: [],
      telVisible: false,
      btCurrentIndex: -1,
      breadcrumbs: [
        {
          name: '发布需求',
          url: '/my/requirement/create/',
        },
      ],
      form: {
        title_picture_id: [],
        picture_ids: [],
        name: '',
        mold_id: '',
        mold_ids: [],
        prov_id: '',
        address: '',
        function: '',
        scale: '',
        phone: '',
        content: '',
        is_hide: '',
        loading: false,
      },
      rules: {
        title_picture_id: [
          {
            required: true,
            message: '请上传封面',
            trigger: 'change',
          },
        ],
        picture_ids: [
          {
            required: true,
            message: '请上传需求图片',
            trigger: 'change',
          },
        ],
        name: [
          {
            required: true,
            message: '请填写需求名称',
            trigger: 'blur',
          },
        ],
        company: [
          {
            required: true,
            message: "请填写业主",
            trigger: "blur"
          }
        ],
        project: [
          {
            required: true,
            message: "请填写设计单位",
            trigger: "blur"
          }
        ],
        mold_id: [
          {
            required: true,
            message: '请选择分类',
            trigger: 'change',
          },
        ],
        mold_ids: [
          {
            required: true,
            message: '请选择子分类',
            trigger: 'change',
          },
        ],
        prov_id: [
          {
            required: true,
            message: '请选择城市',
            trigger: 'change',
          },
        ],
        address: [
          {
            required: true,
            message: '请填写具体地址',
            trigger: 'blur',
          },
        ],
        function: [
          {
            required: true,
            message: '请填写具体功能',
            trigger: 'blur',
          },
        ],
        scale: [
          {
            required: true,
            message: '请填写具体规模',
            trigger: 'blur',
          },
        ],
        phone: [
          {
            required: true,
            message: '请填写手机号码',
            trigger: 'blur',
          },
          {
            pattern: /^0{0,1}(1)[0-9]{10}$/,
            message: '手机号码格式不正确',
            trigger: 'blur',
          },
        ],
        content: [
          {
            required: true,
            message: '请填写内容详情',
            trigger: 'blur',
          },
        ],
      },
      renderItems: {
        title_picture_id: {
          fileList: [],
          type: 'img',
          title: '上传封面图片',
          hint: '支持上传jpg/png/gif格式。',
          limit: 1,
          exhint: '必须上传项目图片，才可提交',
        },
        picture_ids: {
          fileList: [],
          type: 'img',
          title: '上传需求图片',
          hint: '支持上传jpg/png/gif格式，不超过10M，最多6张',
          limit: 6,
          exhint: '必须上传项目图片，才可提交',
        },
        name: {
          type: 'text',
          title: '需求名称',
          hint: '您的名称您做主',
          length: 'long',
        },
        company: {
          type: "text",
          title: "业主",
          hint: "请填写您的业主",
        },
        project: {
          type: "text",
          title: "设计单位",
          hint: "请填写您的设计单位",
        },
        mold_id: {
          type: 'select',
          placeholder: '请选择分类',
          title: '需求分类',
          hint: '请选择您对该需求的分类',
          options: [],
          onChange: this.moldOnChange,
        },
        mold_ids: {
          type: 'checkbox',
          title: '需求子分类',
          hint: '请选择您对该需求的子分类',
          options: [],
          loading: false,
        },
        prov_id: {
          type: 'select',
          placeholder: '请选择所在城市',
          title: '需求城市',
          hint: '请选择您的需求所在城市',
          options: [],
          onChange: false,
        },
        address: {
          type: 'text',
          title: '设计所在地',
          hint: '请填写您的设计所在地',
        },
        function: {
          type: 'text',
          title: '项目功能',
          hint: '请填写该项目的功能',
          length: 'long',
        },
        scale: {
          type: 'text',
          title: '项目规模',
          hint: '请填写该项目的规模',
          length: 'long',
        },
        phone: {
          type: 'text',
          title: '联系电话',
          hint: '请填写您的联系电话',
        },
        content: {
          type: 'textarea',
          maxlength: 200,
          title: '需求描述',
          hint: '此处填写格式为，/建筑类型/ + /什么部位/ 需求 /何种材料/，应用面积为多少。',
        },
      },
      renderBts: [
        {
          label: '发布需求',
          type: 'submit',
          onClick: this.onValidate,
          classes: 'fix-width',
          extendParams: {
            is_hide: 0,
          },
        },
        {
          label: '支付0.9元隐藏手机发布',
          type: 'submit',
          onClick: this.onValidate,
          classes: 'bg-blue fix-width',
          extendParams: {
            is_hide: 1,
          },
        },
        {
          label: '取消',
          type: 'cancel',
          onClick: this.onCancel,
        },
      ],
      dividerConfig: [
        {
          text: '需求信息',
          relatedItem: 'name',
        },
      ],
      pay: {
        visible: false,
        desc: '',
        price: 0,
      },
      formDisabled: false
    };
  },
  watch: {
    molds(val) {
      console.log(val)
      this.renderItems.mold_id.options = val;
    },
    cities(val) {
      this.renderItems.prov_id.options = val;
    },
    type: {
      handler(val) {
        if (val === 'important') {
          this.breadcrumbs['0'].name = '发布项目'
          this.dividerConfig['0'].text = '项目信息'
          this.renderItems.name.title = '项目名称'
          this.renderItems.mold_id.title = '项目分类'
          this.renderItems.prov_id.title = '所在城市'
          this.renderItems.address.hidden = true
          this.renderBts.splice(1, 1)
          this.rules.address['0'].required = false
        }
      },
      immediate: true
    }
  },
  created() {
    const that = this
    that.renderItems.mold_id.options = that.molds || [];
    that.renderItems.prov_id.options = that.cities || [];
    if (that.type === 'important') {
      // 经销商发布重点需求，
      // form 新增所属材料厂家

      if (Number(that.userInfo.identity) === IDENTITY_DEALER) {
        // 如果是经销商 要选择所属厂家
        belongedMerchants().then(res => {
          const { data } = res
          this.formDisabled = data.length === 0
          if (data.length > 0) {
            that.$set(that.form, 'merchant', '')
            that.$set(that.renderItems, 'merchant', {
              type: 'select',
              placeholder: '请选择所属厂家',
              title: '所属材料厂家',
              hint: '',
              options: data,
              onChange: false,
            })
            that.rules.merchant = [
              {
                required: true,
                message: '请选择所属厂家',
                trigger: 'change',
              },
            ];
          }
        })
      }

      // 重点项目 新增是否可见
      that.$set(that.form, 'is_show', '')
      that.$set(that.renderItems, 'is_show', {
        type: 'select',
        placeholder: '是否在本平台对外显示',
        title: '显示',
        hint: '',
        options: [
          {
            id: 0,
            name: '不显示'
          },
          {
            id: 1,
            name: '显示'
          }
        ],
        onChange: false,
      })
      that.rules.is_show = [
        {
          required: true,
          message: '请选择是否对外显示',
          trigger: 'change',
        },
      ];
    }
  },
  mounted() {
    if (this.type === 'important') {
      this.renderItems['requireDetail'] = {
        type: "rich-textarea",
        title: "项目描述",
        hint: "填写项目描述，需包含项目名称、项目规模、项目设计、项目甲方、项目施工、项目阶段、项目需求等等，以及案例效果图（如有），此部分不会对外公开。",
        data: "",
      }
      this.form['requireDetail'] = ''
      this.rules['requireDetail'] = [
        {
          required: true,
          message: '请填写项目描述',
          trigger: 'blur',
        },
      ]
    }
  },
  methods: {
    moldOnChange(id) {
      this.getChildMolds(id);
      // this.getDemandForRandomStoreList()
    },
    async getChildMolds(id) {
      this.renderItems.mold_ids.loading = true;
      const res = await molds(id);
      const { list } = res.data;
      this.renderItems.mold_ids.options = list;
      this.renderItems.mold_ids.loading = false;
    },
    onValidate(extendParams, e) {
      const target = e.currentTarget;
      const { index } = target.dataset;
      this.btCurrentIndex = index;
      if (extendParams.is_hide === 1) {
        this.onPay({
          body: '支付0.9元隐藏手机号发布需求',
          price: 0.9,
        });
      } else {
        this.$refs.postForm.onFormValidate(extendParams);
        this.loading = true;
      }
    },
    onHidePhone() { },
    async onSubmit(val) {
      const formData = val;
      const that = this;
      if (this.type === 'important') {
        formData.type = 'important'
      }
      try {
        await create(formData);
        that.$message({
          type: 'success',
          message: '发布成功',
          duration: 1000,
          onClose() {
            if (that.userInfo.identity == 4 || that.userInfo.identity == 8) {
              that.getDemandForRandomStoreList()
            } else {
              that.$router.push({
                path: '/search/requirement',
              });
              that.onCancel();
            }
          },
        });
      } catch (err) {
        console.log(err);
      }
      that.loading = false;
    },
    onCancel() {
      console.log('cancel');
    },
    onPay(data) {
      this.pay = {
        visible: true,
        desc: data.body,
        price: data.price,
      };
    },
    afterPay(ordernum) {
      this.payCallback(ordernum);
      // 继续发布
      this.$refs.postForm.onFormValidate({
        is_hide: 1,
      });
      this.loading = true;
    },
    payCallback(ordernum) {
      this.$http.post('html/Wxpay/releaseNotify', {
        pay_money: 0.9,
        pay_type: 3,
        order_num: ordernum,
        demand_id: '',
      });
    },
    onFormError(err) {
      console.log(err);
      this.loading = false;
    },
    async getDemandForRandomStoreList() {
      this.telVisible = true;
      this.telList = []
      let params = {
        limit_num: 10,
        mold_id: this.form.mold_id,
        mold_ids: this.form.mold_ids,
      };
      try {
        let data = await getDemandForRandomStoreList(params);
        console.log(data.data.list, 898);
        this.telList = data.data.list;
      } catch (err) {
        console.log(err);
      }
      this.loading = false;
    },
    onClose() {
      this.telVisible = false
      this.$router.push({
        path: '/search/requirement',
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.requirement-edit__wrapper {
  &.disabled {
    position: relative;

    &::after {
      content: '';
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background-color: rgba(0, 0, 0, .7);
    }

    .disabled-hint {
      font-size: 18px;
      color: #fff;
      position: absolute;
      top: 70px;
      left: 50%;
      transform: translateX(-50%);
      z-index: 2;
      font-weight: bold;
    }
  }
}

.tel-dialog {
  .tel-dia-c {
    max-height: 666px;
    overflow-y: auto;
  }

  .item-c {
    border-bottom: 1px solid #eee;
    padding: 10px 0;

    &:last-child {
      border-bottom: unset;
    }
  }

  .item-center-c {
    width: 66%;

    h3 {
      margin-bottom: 6px;
    }
  }

  .el-button--mini {
    height: 30px;
  }

  .gridtable {
    border-collapse: collapse;

    th {
      line-height: 36px;
    }

    td,
    th {
      text-align: left;
    }

    tr {
      td {
        line-height: 36px;
      }

      &:nth-child(odd) {
        background: rgba(0, 0, 0, 0.05);
      }
    }
  }
}
</style>
